import React, { useEffect, useRef, useState } from 'react'
import { get } from 'lib/api'
import { useNavigate, useParams } from 'react-router-dom'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import Upload from './components/Upload'

import LogoWhite from '../EventNew/ttn.png'
import Wallpaper from './2D1A7138.jpg'
import FaceMatch from './components/FaceMatch'
import { Stories } from './components/Stories'

const EventNewUpload: React.FC = () => {
  const pageRef = useRef<HTMLDivElement>(null)

  const [event, setEvent] = useState<any>(null)
  const [status, setStatus] = useState<'upload' | 'face-match' | 'stories'>(
    'upload'
  )

  const navigate = useNavigate()
  const { code } = useParams()

  const { authenticated } = useSelector((state: any) => state.user)

  const fetchEvent = async () => {
    try {
      const { data } = await get(`/event/get-event/${code}`)

      setEvent(data)

      if (pageRef.current) {
        pageRef.current.style.opacity = '1'
      }
    } catch (e) {
      const error = e as AxiosError

      if (error.response) {
        if (error.response.status === 404) {
          navigate('/404')

          return
        }

        const data = error.response.data as {
          error: {
            status: number
            message: string
          }
        }

        toast.error(data.error.message)
      }
    }
  }

  useEffect(() => {
    if (!code) {
      return
    }

    fetchEvent()
  }, [code])

  return (
    <div
      ref={pageRef}
      className="h-full bg-[#000] text-white opacity-0 transition-opacity duration-[250ms] font-morebi"
    >
      <div className="absolute top-[24px] left-1/2 -translate-x-1/2 z-10">
        <img src={LogoWhite} alt="" className="w-[125px]" />
      </div>
      <div
        className="relative w-full bg-cover bg-center h-[375px] flex flex-col justify-end"
        style={{
          backgroundImage: `url(${Wallpaper})`,
        }}
      >
        <div className="relative z-20 flex items-start gap-[10px] px-[30px] pb-[20px]">
          <div className="flex-1 text-[28px] font-bold mt-[4px]">
            {event?.name}
          </div>
          {event?.event_date && (
            <div
              className="flex flex-col items-center justify-center w-[60px] h-[60px] text-white font-bold shrink-0"
              style={{
                background:
                  'radial-gradient(circle at 100% 100%, #000000 0, #000000 14px, transparent 14px) 0% 0%/15px 15px no-repeat, radial-gradient(circle at 0 100%, #000000 0, #000000 14px, transparent 14px) 100% 0%/15px 15px no-repeat, radial-gradient(circle at 100% 0, #000000 0, #000000 14px, transparent 14px) 0% 100%/15px 15px no-repeat, radial-gradient(circle at 0 0, #000000 0, #000000 14px, transparent 14px) 100% 100%/15px 15px no-repeat, linear-gradient(#000000, #000000) 50% 50%/calc(100% - 2px) calc(100% - 30px) no-repeat, linear-gradient(#000000, #000000) 50% 50%/calc(100% - 30px) calc(100% - 2px) no-repeat, linear-gradient(0deg, transparent 0%, rgba(214,255,0,0.3) 100%)',
                borderRadius: '15px',
                boxSizing: 'border-box',
              }}
            >
              <div className="text-[13px]">
                {new Date(event.event_date).toLocaleDateString('tr-TR', {
                  month: 'long',
                })}
              </div>
              <div className="text-[26px] -mt-[8px]">
                {new Date(event.event_date).getDate()}
              </div>
            </div>
          )}
        </div>
        <div
          className="absolute -bottom-[1px] left-0 w-full h-full rotate-180"
          style={{
            background:
              'linear-gradient(180deg, #000 0%, #000 0.01%, rgba(0, 0, 0, 0.00) 100%)',
          }}
        />
      </div>
      {status === 'upload' && (
        <Upload
          event={event}
          onClickFaceMatch={() => setStatus('face-match')}
          onClickStories={() => {
            if (authenticated) {
              setStatus('stories')
            } else {
              navigate(`/login?event=${code}`)
            }
          }}
        />
      )}
      {status === 'face-match' && (
        <FaceMatch event={event} onSuccess={() => setStatus('upload')} />
      )}
      {status === 'stories' && <Stories event={event} />}
    </div>
  )
}

export default EventNewUpload
